export const CLASSNAME_PREFIX = 'chakra-react-select';
export const MAX_MENU_HEIGHT_PIXELS = 343;
export const OPTION_HEIGHT_PIXELS = 49;
export const GROUP_HEADER_HEIGHT_PIXELS = 32; // 24px height + 8px margin top
